import { Modal, Text } from '@/shared/ui'

import cls from './close-chat-apply-modal.module.scss'

type CloseChatApplyModalProps = {
	isOpen: boolean
	onClose: () => void
	onApply: () => void
}

export const CloseChatApplyModal = ({ isOpen, onApply, onClose }: CloseChatApplyModalProps) => {
	const onCancel = () => {
		onApply()
		onClose()
	}

	return (
		<Modal
			contentClassName={cls.root}
			withoutCloseAnimation
			isOpen={isOpen}
			onClose={onClose}
			onOk={onClose}
			onCancel={onCancel}
			okText="Подождать"
			cancelText="Закрыть">
			<Text size="6" weight="medium">
				Вы точно хотите закрыть чат?
			</Text>
			<Text size="5">Чат бот совсем скоро ответит, буквально пара секунд.</Text>
		</Modal>
	)
}
